// @ts-strict-ignore
import { Injectable } from '@angular/core';
import { ArticleContainer } from '@3d-scene/model3d/article-container';
import { ConnectionFactory } from '@3d-scene/model3d/connection.factory';
import { ArticleContainerUtils } from '@3d-scene/model3d/util/article-container-utils';
import { ContainerService } from '@3d-scene/model3d/container.service';
import { InsertArticleUtils } from '@project/components/article/util/insert-article-utils';
import { ConnectionAreaVO, MetaElementUsageIdentityVO } from '@shared/vo/meta-element.vo';
import { ArticleUsageVO, ArticleVO } from '../model/vo/article.vo';
import { ArticleUsageUtils } from '../util/article-usage-utils';
import { ArticleLineHolder } from './article-line-holder';
import { InsertArticleHelper } from './insert-article.helper';
import { ConnectionInfoUtils } from '@3d-scene/model3d/util/connection-info-utils';

@Injectable({ providedIn: 'root' })
export class InsertArticleHelperFactory {
  constructor(
    private _componentUtils: ContainerService,
    private _connectionFactory: ConnectionFactory,
    private _articleContainerUtils: ArticleContainerUtils,
    private _insertArticleUtils: InsertArticleUtils,
    private _articleLineHolder: ArticleLineHolder
  ) {}

  public createInstanceByAcceptingContainer(articleContainer: ArticleContainer, metaElementName: string): InsertArticleHelper {
    return new InsertArticleHelper(
      articleContainer,
      metaElementName,
      this._componentUtils,
      this._connectionFactory,
      this._insertArticleUtils,
      this._articleContainerUtils,

      this._articleLineHolder
    );
  }

  public createInstanceByAcceptingIdentity(identity: MetaElementUsageIdentityVO): InsertArticleHelper {
    const articleContainer: ArticleContainer = this._componentUtils.findArticleContainerInGlobal(identity.articleUsageId);
    return this.createInstanceByAcceptingContainer(articleContainer, identity.metaElementName);
  }

  public createInstanceByRangeOnLineArticleContainer(
    rangeOnLineArticleContainer: ArticleContainer,
    rangeOnLineType: string = null
  ): InsertArticleHelper {
    if (!rangeOnLineArticleContainer) {
      return null;
    }
    const article: ArticleVO = rangeOnLineArticleContainer.article;
    const acceptingConnection: ConnectionAreaVO = ConnectionInfoUtils.findRangeOnLineConnectionByType(article.metaElements, rangeOnLineType);
    return !acceptingConnection ? null : this.createInstanceByAcceptingContainer(rangeOnLineArticleContainer, acceptingConnection.name);
  }

  public createInstanceByConnectedArticleContainer(articleContainer: ArticleContainer): InsertArticleHelper {
    if (!articleContainer || !articleContainer.articleUsage) {
      return null;
    }
    return this.createInstanceByConnectedArticleUsage(articleContainer.articleUsage);
  }

  public createInstanceByConnectedArticleUsage(articleUsage: ArticleUsageVO): InsertArticleHelper {
    const parentMetaIds: MetaElementUsageIdentityVO[] = ArticleUsageUtils.getBackwardConnectedConnectionUsageIds(articleUsage);
    if (parentMetaIds.length !== 1) {
      return null;
    }

    const parentMetaUsageId: MetaElementUsageIdentityVO = parentMetaIds[0];
    const parentContainer: ArticleContainer = this._componentUtils.findArticleContainerInGlobal(parentMetaUsageId.articleUsageId);
    if (!parentContainer) {
      return null;
    }
    return this.createInstanceByAcceptingContainer(parentContainer, parentMetaUsageId.metaElementName);
  }
}
